import React from 'react';
import { contentRoot, heading, text } from './styles';

function BrowserInvalid() {
  return (
    <div className={contentRoot}>
      <h1 className={heading}>
        Lyearn only works on the latest version of{' '}
        <a href="https://www.google.com/chrome/">Google Chrome</a> browser currently
      </h1>
      <p className={text}>Apologies for the inconvenience</p>
    </div>
  );
}

export default BrowserInvalid;
